import { Link as RouterLink } from 'react-router-dom'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { bodyText, colours } from './playerStyles'

const nextStep = ({ enrolmentId, enrolment, assessment, feedbackSubmitted, revisitTitles }) => {
  const base = `/training/course/${enrolmentId}`
  if (enrolment?.status === 'completed') {
    return {
      heading: 'You have completed this course',
      text: 'Your certificate is ready.',
      action: { label: 'View your certificate', to: `${base}/certificate` },
    }
  }
  if (enrolment?.passed && !feedbackSubmitted) {
    return {
      heading: 'You have passed the assessment',
      text: 'Give your feedback on the course to unlock your certificate.',
      action: { label: 'Give your feedback', to: `${base}/feedback` },
    }
  }
  if (enrolment?.passed) {
    return {
      heading: 'You have passed the assessment',
      text: 'Your certificate is ready.',
      action: { label: 'View your certificate', to: `${base}/certificate` },
    }
  }
  if (assessment?.open) {
    return {
      heading: 'You have finished the course content',
      text: 'The last step is the assessment. You can go back over any screen first.',
      action: { label: 'Start the assessment', to: `${base}/assessment` },
    }
  }
  if (assessment?.reason === 'revisit') {
    return {
      heading: 'Look at these modules again',
      text: 'Before you retake the assessment, open every screen of the modules below again. Use the course outline to go to each one.',
      list: revisitTitles,
    }
  }
  return {
    heading: 'You have reached the end of the course',
    text: 'The assessment opens once every screen is complete. Use the course outline to find any screen you have not finished.',
  }
}

// Replaces Next on the last screen once the course content is done.
const CompletionPanel = (props) => {
  const { heading, text, list, action } = nextStep(props)
  return (
    <Box
      component="section"
      aria-labelledby="completion-heading"
      sx={{ mt: 3, p: { xs: 2, sm: 3 }, border: `2px solid ${colours.good}`, borderRadius: 2, bgcolor: colours.goodSoft }}
    >
      <Typography
        component="h2"
        id="completion-heading"
        sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: '1.25rem', fontWeight: 700, color: colours.text, mb: 1 }}
      >
        <CheckCircleIcon sx={{ color: colours.good }} aria-hidden="true" />
        {heading}
      </Typography>
      <Typography sx={bodyText}>{text}</Typography>
      {list?.length > 0 && (
        <Box component="ul" sx={{ ...bodyText, mt: 1, mb: 0, pl: 3 }}>
          {list.map((title) => (
            <li key={title}>{title}</li>
          ))}
        </Box>
      )}
      {action && (
        <Button component={RouterLink} to={action.to} variant="contained" sx={{ mt: 2 }}>
          {action.label}
        </Button>
      )}
    </Box>
  )
}

export default CompletionPanel
